import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * BetaBanner — Beta soft-launch messaging.
 *
 * Brief Jul 3 2026 : le bandeau change de texte selon l'état de
 * FORCE_FREE_SESSIONS (DB-backed toggle admin) :
 *   • force_free_sessions = true  → "🚀 Beta — Sessions offertes pendant le lancement"
 *   • force_free_sessions = false → bandeau RETIRÉ (les paiements Stripe sont
 *                                    actifs, plus besoin d'annoncer la gratuité)
 *
 * Le composant lit /api/admin/settings/force-free-sessions (accessible à tous
 * les users authentifiés, pas seulement admin). En cas d'erreur (non loggué,
 * network), il masque le bandeau par défaut plutôt que d'afficher un état
 * potentiellement mensonger.
 *
 * Variants preserved for backward compat :
 *   • <BetaBanner variant="dark" />   → for the dark landing (Home.js)
 *   • <BetaBanner variant="light" />  → for the AppShell content area
 */
export const BetaBanner = ({ variant = 'light' }) => {
  const [forceFree, setForceFree] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/admin/settings/force-free-sessions`, { withCredentials: true })
      .then(({ data }) => { if (!cancelled) setForceFree(!!data?.force_free_sessions); })
      .catch(() => { if (!cancelled) setForceFree(false); });
    return () => { cancelled = true; };
  }, []);

  // Loading / paiements Stripe actifs → aucun bandeau.
  if (forceFree !== true) return null;

  const isDark = variant === 'dark';
  return (
    <div
      data-testid="beta-banner"
      role="status"
      aria-label="Information bêta"
      className={
        isDark
          ? 'flex items-center justify-center gap-2 px-4 py-2 text-center text-sm font-medium ' +
            'bg-gradient-to-r from-amber-500/15 via-amber-400/20 to-amber-500/15 ' +
            'text-amber-100 border-b border-amber-400/30 backdrop-blur-sm'
          : 'flex items-center justify-center gap-2 px-4 py-2.5 text-center text-sm font-medium ' +
            'bg-gradient-to-r from-amber-50 via-amber-100 to-amber-50 ' +
            'text-amber-900 border border-amber-200 rounded-xl shadow-sm'
      }
    >
      <span className="text-base leading-none">🚀</span>
      <span>
        <strong className="font-semibold">Beta</strong>
        <span className="mx-2 opacity-60">·</span>
        Sessions offertes pendant le lancement
      </span>
    </div>
  );
};

export default BetaBanner;
